import { useMutation } from 'urql';

import { OptOutSmsDocument, OptOutSmsMutation } from '../generated/sms-opt-out';

export const useSmsOptOut = () => {
  const [state, executeMutation] = useMutation<OptOutSmsMutation, { inviteId: string }>(OptOutSmsDocument);

  const executeOptOut = async (variables: { inviteId: string }) => {
    const result = await executeMutation(variables);
    return {
      success: Boolean(result.data?.optOutSms),
      error: result.error,
    };
  };

  return [state, executeOptOut] as const;
};
